module.exports = __webpack_public_path__ + "img/UserTrainingCourses.22579d13.svg";